<template>
  <div class="card">
    <div
      class="d-flex justify-start align-center mb-1"
      v-for="item in itemsText"
      :key="item"
    >
      <span class="a-text">{{ item }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemsText: ["Tempo", "Contexto", "Nome", "Descrição", "Status"],
    };
  },
};
</script>

<style scoped lang="scss">
.card {
  background: $dark-accent;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 3px;
  max-width: 82px;
}
</style>